<template>
<div class="lightbox" :class="{ 's_active' : lightbox.isActive && ( (!_.isUndefined(lightbox.htmlContent) && !_.isNull(lightbox.htmlContent) && lightbox.htmlContent.length) || (!_.isUndefined(lightbox.gallerySlides) && !_.isNull(lightbox.gallerySlides) && lightbox.gallerySlides.length) ) }" @keydown.esc="close">
  <div class="lightbox-overlay" @click.stop="close"></div>
  <div class="lightbox-content" tabindex="0">
    <div class="lightbox-scroll">

      <div v-html="lightbox.htmlContent" v-if="!_.isUndefined(lightbox.htmlContent) && !_.isNull(lightbox.htmlContent) && lightbox.htmlContent.length" class="lightbox-text"></div>

      <div class="lightbox-media" v-if="lightbox.gallerySlides.length > 1">

        <!-- <Carousel :wrap-around="true" :mouse-drag="false">
          <Slide v-for="slide in lightbox.gallerySlides" :key="slide.id">
            <div class="VueCarousel-slide" v-html="slide.content"></div>
          </Slide>

          <template #addons>
            <Navigation />
            <Pagination />
          </template>
        </Carousel> -->

        <div class="vuegal" ref="vuegal">
          <div class="vuegal__button l_left" @click="prevSlide">
            <div class="vuegal__button-circle">
              <svg class="icon"><use href="#arrow-left"></use></svg>
            </div>
          </div>
          <div class="vuegal__button l_right" @click="nextSlide">
            <div class="vuegal__button-circle">
              <svg class="icon"><use href="#arrow-right"></use></svg>
            </div>
          </div>
          <div class="vuegal__items">
            <div class="vuegal__item" v-for="slide in lightbox.gallerySlides" :key="slide.id">
              <div class="vuegal__image" v-html="slide.content"></div>
            </div>
          </div>
        </div>

        <!-- <div class="vuegal__nav">
          <button class="vuegal__nav-button" v-for="(slide, index) in lightbox.gallerySlides" @click="gotoSlide(index);"></button>
        </div> -->

      </div>

      <div class="lightbox-media" v-else-if="lightbox.gallerySlides.length == 1">
        <div v-html="lightbox.gallerySlides[0].content" class="zoom-container"></div>
      </div>

      <small style="text-align: center; margin-top: 10px;" v-if="lightbox.gallerySlides.length > 0">Images are for illustrations purposes only and do not represent the exact scale of your order given the wall space selected.</small>

    </div>
    <button class="button-circle lightbox-close" @click.stop="close" ref="lightboxContent">
      <svg class="icon"><use xlink:href="#cross"></use></svg>
    </button>
  </div>
</div>
</template>

<script setup>

var _ = require('lodash');

import { ref, watch } from 'vue'

import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel'

import { useLightboxStore } from "@/stores/lightbox";
const lightbox = useLightboxStore();

const lightboxContent = ref(null);
lightbox.refs['lightboxContent'] = lightboxContent;

function close(e) {
  lightbox.close();
}



// import interact from 'interactjs'


// var angleScale = {
//   angle: 0,
//   scale: 1
// }
// var resetTimeout
// var slide = document.querySelector('.zoom-container')
// var scaleElement = document.querySelector('.zoom-container img')

// if (slide) {
//   interact(slide)
//     .gesturable({
//       listeners: {
//         start (event) {
//           angleScale.angle -= event.angle

//           clearTimeout(resetTimeout)
//           scaleElement.classList.remove('reset')
//         },
//         move (event) {
//           // document.body.appendChild(new Text(event.scale))
//           var currentAngle = event.angle + angleScale.angle
//           var currentScale = event.scale * angleScale.scale

//           scaleElement.style.transform =
//             'rotate(' + currentAngle + 'deg)' + 'scale(' + currentScale + ')'

//           // uses the dragMoveListener from the draggable demo above
//           dragMoveListener(event)
//         },
//         end (event) {
//           angleScale.angle = angleScale.angle + event.angle
//           angleScale.scale = angleScale.scale * event.scale

//           resetTimeout = setTimeout(reset, 1000)
//           scaleElement.classList.add('reset')
//         }
//       }
//     })
//     .draggable({
//       listeners: { move: dragMoveListener }
//     })
// }

// function reset () {
//   scaleElement.style.transform = 'scale(1)'

//   angleScale.angle = 0
//   angleScale.scale = 1
// }


const vuegal = ref(null);

// watch changes to the step and update the url
watch(() => lightbox.isActive, (newValue, oldValue) => {
  if (newValue !== oldValue && newValue) {
    resetSlide();
  }
});

function resetSlide() {
  if (vuegal.value) {
    const gallery = vuegal.value.querySelector('.vuegal__items');
    if (gallery) gallery.scrollLeft = 0;
  }
}

function gotoSlide(num) {
  const gallery = vuegal.value.querySelector('.vuegal__items');
  const item = gallery.querySelectorAll('.vuegal__item')[num-1];
  const x = item.offsetLeft;
  gallery.scrollLeft = x;
  gallery.querySelectorAll('.vuegal__item').forEach(el => {
    el.classList.remove('s_active');
  });
  item.classList.add('s_active');
}

function getCurrentSlide() {
  const gallery = vuegal.value.querySelector('.vuegal__items');
  const items = gallery.querySelectorAll('.vuegal__item');
  const galleryWidth = gallery.offsetWidth * items.length;
  const slideWidth = galleryWidth / items.length;
  let currentSlide = Math.ceil((slideWidth + gallery.scrollLeft) / slideWidth) + 1;
  return currentSlide;
}

function nextSlide() {
  const gallery = vuegal.value.querySelector('.vuegal__items');
  const items = gallery.querySelectorAll('.vuegal__item');
  let currentSlide = getCurrentSlide();
  let nextSlide = currentSlide ++;
  if (nextSlide > items.length) nextSlide = 1;
  gotoSlide(nextSlide);
}

function prevSlide() {
  const gallery = vuegal.value.querySelector('.vuegal__items');
  const items = gallery.querySelectorAll('.vuegal__item');
  let currentSlide = getCurrentSlide();
  let nextSlide = currentSlide --;
  if (nextSlide < 1) nextSlide = items.length;
  gotoSlide(nextSlide);
}



</script>
